import { render, staticRenderFns } from "./ChannelProviderList.vue?vue&type=template&id=6c1970d2"
import script from "./ChannelProviderList.vue?vue&type=script&lang=js"
export * from "./ChannelProviderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports